import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../../../../components/SearchForm/components/FieldChrome/components/Container.js';
import { Content } from '../../../../components/SearchForm/components/FieldChrome/components/Content.js';
import { Icon } from '../../../../components/SearchForm/components/FieldChrome/components/Icon.js';
import { Label } from '../../../../components/SearchForm/components/FieldChrome/components/Label.js';
import { Value } from '../../../../components/SearchForm/components/FieldChrome/components/Value.js';
import { ValueWrapper } from '../../../../components/SearchForm/components/FieldChrome/components/ValueWrapper.js';
import { SPACING_XSMALL } from '../../../../utils/spacingLegacy.js';
export const FieldChrome = /*#__PURE__*/_styled(forwardRef(function FieldChrome({
  label,
  value,
  placeholder,
  prependIcon,
  appendIcon,
  visuallyFocused,
  invalid,
  children,
  layout,
  ...restProps
}, ref) {
  return _jsxs(Container, {
    ref: ref,
    ...restProps,
    large: layout === 'compact',
    inverted: layout === 'sidebar',
    direction: "row",
    focused: visuallyFocused,
    invalid: invalid,
    spacing: 0.75,
    children: [prependIcon && _jsx(Icon, {
      "data-testid": "textfield-prepend-icon",
      children: prependIcon
    }), _jsxs(Content, {
      spacing: SPACING_XSMALL,
      children: [_jsx(Label, {
        children: label
      }), _jsx(Value, {
        children: children || _jsx(ValueWrapper, {
          value: value,
          placeholder: placeholder
        })
      })]
    }), appendIcon && _jsx(Icon, {
      "data-testid": "textfield-append-icon",
      children: appendIcon
    })]
  });
}), process.env.NODE_ENV === "production" ? {
  target: "e2tcyyc0"
} : {
  target: "e2tcyyc0",
  label: "FieldChrome"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");